<template>
    <div id="app">
        <!--购物车-->
        <div class="Srig-group" @click="shopping_hide_1"></div>
        <div class="Srig">
            <div class="shopping-car-page">
                <div @click="shopping_hide_1" style="text-align: left">
                    <img src="./assets/store/back_android.png" width="18" style="position: relative;">
                    <span class="shopping_span">{{$t('shopping_card_pack_up')}}</span>
                </div>
                <h1 class="shopping-title">{{$t('shopping_card_title')}}</h1>
                <Row style="width: 90%;margin: 5% auto;" v-if="goods.length > 0">
                    <i-col :xs="12" :sm="12" :md="12" :lg="12" style="text-align: left">
                        <Checkbox style="font-size: 14px;color: #5E6D82;" @on-change="selectAll" class="checkALL"
                                  v-model="checkALL">
                            {{$t('shopping_card_selected')}}
                        </Checkbox>
                    </i-col>
                    <i-col :xs="12" :sm="12" :md="12" :lg="12" style="text-align: right;">
                        <a href="javascript:;" @click="goToOrderList"><img src="./assets/store/full.png" width="20"></a>
                    </i-col>
                </Row>
                <Row width="100%" class="shopping-car-main-page">
                    <i-col :span="24" style="background: white;margin-top: 15px;" v-for="(item,index,key) in goods"
                           :key="index">
                        <div class="shopping-product" style="margin:5% auto;width: 90%;display: flex">
                            <div style="width: 5%;">
                                <Checkbox style="font-size: 14px;color: #5E6D82;" v-model="item.if_checked"></Checkbox>
                            </div>
                            <div style="width: 30%;margin:10px;">
                                <img :src="item.goods_img" width="100%"  @click="detail(item)">
                            </div>
                            <div style="width: 40%;padding:0 10px;position: relative;max-height: 100px;">
                                <p style="font-size: 16px;color: #5E6D82;text-align: left">{{item.goods_name}}</p>
                                <div class="shopping-number" style="margin-top: 10%;">
                                  <button style="position: absolute;border:none;left: 8%;background: #99A9BF;
                                  border-radius: 5px 0 0 5px;
                                  width: 40px;height: 30px;
                                  color: white;font-size:24px;"
                                          @click="min(index)">
                                        <span style="position: absolute;top:-4px;left: 15px;">-</span>
                                  </button>
                                    <span class="shopping-product-number" width="20"
                                          style="position: absolute;left: 45%;font-size: 19px;">{{item.goods_num}}</span>
                                    <button style="position: absolute;right: 10%;background: #99A9BF;border-radius: 0 5px 5px 0;
                                    border:none;width: 40px;height: 30px;
                                    color: white;font-size:20px;" @click="max(index)">
                                        <span style="position: absolute;top:-1px;left: 12px;">+</span>
                                    </button>
                                </div>
                            </div>
                            <div style="width: 25%;text-align: right">
                                <div class="shopping-remove-product"
                                     @click="remove_order(index)">
                                    <img src="./assets/store/icon-close.png" width="20">
                                </div>
                                <div class="shopping-product-price"
                                     style="font-size: 24px;color: #5E6D82;margin-top: 15%;">
                                     ${{parseFloat(item.goods_price) * item.goods_num}}
                                </div>
                            </div>
                        </div>
                    </i-col>
                </Row>
                <div class="empty-cart" v-if="goods.length == 0">
                    <img src="./assets/profile/empty-cart.png" alt="">
                    <p>{{$t('shopping_card_null')}}</p>
                    <!--<router-link :to="{name:'Store'}" class="text-primary">Go to shopping</router-link>-->
                    <a @click="goToShopping">{{$t('shopping_card_go_to_shopping')}}</a>
                </div>
                <Row style="position: absolute;top:80%;right:0%;width: 100%;background: #f9fcff;padding-right:25px;" v-if="goods.length > 0">
                    <i-col :span="24" width="80%"
                           style="margin:20px auto;text-align: right;">
                        <p style="font-size: 24px;color: #5E6D82;">
                            {{$t('shopping_card_total', {count: orderNumberTotal})}} USD ${{orderTotal}}</p>
                        <button class="Product-shopping-btn" @click="checkOut">
                            {{$t('check_out_btn')}}
                        </button>
                    </i-col>
                </Row>
            </div>
        </div>
        <div class="body-content-container">
            <router-view></router-view>
        </div>
        <!--公共尾部-->
        <div class="footer" style="margin-top: 3px;">
            <div class="layout-copy">
                <Row class="max_width">
                    <Col :sm="24" :md="12" :lg="14">
                    <div class="layout-copy-main" id="pc_footer">
                        <Row style="" class="footer-row">
                            <Col :xs="8" :sm="8" :md="8" :lg="8" class="copy-g">
                            <div class="copy-header">
                                <router-link :to="{name:'FooterShop'}">
                                    <p class="copy-title">{{$t('footer_shop')}}</p>
                                </router-link>
                                <router-link :to="{name:'mogos',query:{id:1}}">
                                    <p class="copy-item">MOGO S</p>
                                </router-link>
                                <router-link :to="{name:'Go'}">
                                    <p class="copy-item">iGo</p>
                                </router-link>
                                <router-link :to="{name:'Connect'}">
                                    <p class="copy-item">iConnect</p>
                                </router-link>
                            </div>
                            </Col>
                            <Col :xs="8" :sm="8" :md="8" :lg="8" class="copy-g">
                            <div class="copy-header">
                                <p class="copy-title">{{$t('footer_about_ifree')}}</p>
                                <router-link :to="{name:'AboutiFREE'}">
                                    <p class="copy-item">{{$t('footer_about_us')}}</p>
                                </router-link>
                                <router-link :to="{name:'information'}">
                                    <p class="copy-item">{{$t('footer_media')}}</p>
                                </router-link>
                                <router-link :to="{name:'ContactUs'}">
                                    <p class="copy-item">{{$t('footer_Regional')}}</p>
                                </router-link>
                            </div>
                            </Col>
                            <Col :xs="8" :sm="8" :md="8" :lg="8" class="copy-g">
                            <div class="copy-header">
                                <p class="copy-title">{{$t('footer_support')}}</p>
                                <router-link :to="{name:'HowTobuy'}">
                                    <p class="copy-item">{{$t('footer_howtoway')}}</p>
                                </router-link>
                                <router-link :to="{name:'PhysicalStore'}">
                                    <p class="copy-item">{{$t('footer_Resellers')}}</p>
                                </router-link>

                                <router-link :to="{name:'Services'}">
                                    <p class="copy-item">{{$t('footer_FAQ')}}</p>
                                </router-link>
                            </div>
                            </Col>
                        </Row>
                    </div>
                    <div class="mobile-footer">
                        <Collapse v-model="value2" accordion>
                            <Panel name="1">
                                <router-link :to="{name:'FooterShop'}">
                                    {{$t('footer_shop')}}
                                </router-link>
                                <p slot="content" class="copy-title">
                                    <router-link :to="{name:'mogos',query:{id:1}}">
                                <p class="copy-item">MOGO S</p>
                                </router-link>
                                <router-link :to="{name:'Go'}">
                                    <p class="copy-item">iGo</p>
                                </router-link>
                                <router-link :to="{name:'Connect'}">
                                    <p class="copy-item">iConnect</p>
                                </router-link>
                                </p>
                            </Panel>
                            <Panel name="2">
                                {{$t('footer_about_ifree')}}
                                <p slot="content" class="copy-title">
                                    <router-link :to="{name:'AboutiFREE'}">
                                <p class="copy-item">{{$t('footer_about_us')}}</p>
                                </router-link>
                                <router-link :to="{name:'information'}">
                                    <p class="copy-item">{{$t('footer_media')}}</p>
                                </router-link>
                                <router-link :to="{name:'ContactUs'}">
                                    <p class="copy-item">{{$t('footer_Regional')}}</p>
                                </router-link>
                                </p>
                            </Panel>
                            <Panel name="3">
                                {{$t('footer_support')}}
                                <p slot="content" class="copy-title">
                                    <router-link :to="{name:'HowTobuy'}">
                                <p class="copy-item">{{$t('footer_howtoway')}}</p>
                                </router-link>
                                <router-link :to="{name:'PhysicalStore'}">
                                    <p class="copy-item">{{$t('footer_Resellers')}}</p>
                                </router-link>

                                <router-link :to="{name:'Services'}">
                                    <p class="copy-item">{{$t('footer_FAQ')}}</p>
                                </router-link>
                                </p>
                            </Panel>
                        </Collapse>
                    </div>
                    </Col>
                    <Col :xs="24" :sm="24" :md="6" :lg="10">
                    <Row>
                        <div class="qr-main">
                            <Col :xs="24" :sm="24" :md="24" :lg="24" style="padding-top: 12%;">
                            <p class="copy-title">{{$t('contact_us_mainpage_title')}}</p>
                            <div class="Social_group">
                                <div class="Social_icon" v-for="(item,index) in social" :key="index">
                                    <a>
                                        <img :src="item.img"  width="38" @mouseout="mousehide()" @click="qrcodeShow(index)" @mouseover="mouseShow(index)">
                                    </a>
                                </div>
                                <div class="Social_qrcode" v-show="thisQR">
                                    <img src="./assets/iapp.png" width="55%" v-if="this.qrcode == 'iapp' ">
                                    <img src="./assets/wechat_qr.jpg" width="60%" v-else-if="this.qrcode == 'wechat' ">
                                    <p v-if="this.qrcode == 'iapp' ">
                                        {{$t('user_center_iapp_qrcode')}}
                                    </p>
                                    <p v-else-if="this.qrcode == 'wechat' ">
                                        {{$t('contact_way2')}}
                                    </p>
                                    <div id="mydiv"></div>
                                </div>
                            </div>
                            </Col>
                            <div class="layout-copy1" style="text-align: left">
                                <p style="text-align: left;margin: 5px 0">&nbsp<router-link  to="/terms_of_law"
                                >{{$t('agree_terms_of_law')}}</router-link>&nbsp&nbsp|&nbsp<router-link style="padding:0 2px;" :to="{name:'terms_of_service'}">{{$t('agree_terms_of_conditions')}}</router-link>&nbsp|&nbsp<router-link style="padding:0 2px;" :to="{name:'privacy_policy'}">{{$t('agree_privacy_policy')}}</router-link>
                                    | <router-link  style="padding:0 2px;" :to="{name:'sales_and_refund'}">{{$t('return_policy')}}</router-link>
                                </p>
                                Copyright © 2018 iFREE GROUP Inc. All rights reserved.

                            </div>

                        </div>
                    </Row>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    import Signature from './lib/Signature'
    import modal from './components/Common/Modal.vue'

    export default {
        data () {
            return {
                goods: [],
                size: 'large',
                modal1: false,
                thisQR:false,
                value2: '',
                qrcode:'',
                checkALL:true,
                QRcode:true,
                social:[
                    {
                        img:require('./assets/home/new_home/ic_facebook@2x.png')
                    },
                    {
                        img:require('./assets/home/new_home/ic_youtube@2x.png')
                    },
                    {
                        img:require('./assets/home/new_home/ic_wechat@2x.png')
                    },
                    {
                        img:require('./assets/home/new_home/ic_iapp@2x.png')
                    }

                ]
            }
        },
        name: 'app',
        conponents:{
            modal
        },
        methods: {
            mousehide () {
                this.thisQR = false
            },
            mouseShow(index){
                if (index ==2){
                    this.thisQR = true
                    this.qrcode = 'wechat'
                    $('.Social_qrcode').css('left','37%')

                }else if (index ==3){
                    this.thisQR = true
                    this.qrcode = 'iapp'
                    $('.Social_qrcode').css('left','63%')
                }
            },
            //二维码扫描
            qrcodeShow (index) {
                if(index === 0){
                    this.thisQR = false
                    window.location.href='https://fb.me/ifreegroupofficial'
                }else if (index ==1){
                    this.thisQR = false
                    window.location.href='https://www.youtube.com/channel/UCRO7Nrnok7w4Eth-UKGlx4w'
                }else if (index ==2){
                    this.thisQR = !this.thisQR
                    this.qrcode = 'wechat'
                    $('.Social_qrcode').css('left','37%')
                }else if (index ==3){
                    this.thisQR = !this.thisQR
                    this.qrcode = 'iapp'
                    $('.Social_qrcode').css('left','63%')
                }
            },
            detail (item) {
                if (item.goods_alias) {
                    this.$router.push({
                        path: '/product/' + item.goods_alias,
                        query: {
                            id: item.goods_id
                        }
                    })
                    return
                }
                this.$router.push({
                    name: 'ProductDetails',
                    params: {
                        id: item.goods_id
                    }
                })
            },
            goToShopping () {
                this.$router.push({
                    name: 'FooterShop'
                })
                this.shopping_hide_1()
            },
            checkOut () {
                if (this.orderTotal === 0) {
                    this.$Message.error(this.$t('user_message_please_choose_product'))
                    return false
                }

                let data = {}
                data.goods_id = []
                data.number = []
                for (let item of this.goods) {
                    if (item.if_checked === true) {
                        data.goods_id.push(item.goods_id)
                        data.number.push(item.goods_num)
                        item.if_checked = false
                    }
                }
                data.goods_id = data.goods_id.join(',')
                data.number = data.number.join(',')

                //判断用户登录
                if (!this.Local.isLogin()) {
                    this.$busEvent.$emit('login')
                    this.shopping_hide_1()
                    //存购物车数据
                    this.Local.set('CartGoods_id',data.goods_id)
                    this.Local.set('CartGoods_number',data.number)
                }else{
                    this.$router.push({
                        name: 'Settlement',
                        query: {
                            goods_id: data.goods_id,
                            number: data.number
                        }
                    })
                    for (let item of this.goods) {
                        if (item.if_checked === true) {
                            item.if_checked = false
                        }
                    }
                    $('.checkALL').removeClass('ivu-checkbox-wrapper-checked')
                    $('.checkALL .ivu-checkbox').removeClass('ivu-checkbox-checked')
                    this.shopping_hide()
                }
            },
            selectAll (type) {
                for (let i in this.goods) {
                    if (type) {
                        this.goods[i]['if_checked'] = true
                    } else {
                        this.goods[i]['if_checked'] = false
                    }
                }
            },
            goToOrderList () {
                let data = {}
                data.goods_id = []
                data.number = []
                for (let item of this.goods) {
                    if (item.if_checked === true) {
                        data.goods_id.push(item.goods_id)
                        data.number.push(item.goods_num)
                        item.if_checked = false
                    }
                }
                data.goods_id = data.goods_id.join(',')
                data.number = data.number.join(',')

                //判断用户登录
                if (!this.Local.isLogin()) {
                    this.$busEvent.$emit('login')
                    this.shopping_hide_1()
                    //存购物车数据
                    this.Local.set('CartGoods_id',data.goods_id)
                    this.Local.set('CartGoods_number',data.number)
                }
                this.$router.push({name: 'ShoppingCart'})
                this.shopping_hide()
            },
            showmenu () {
                $('.hide-menu').toggle()
            },
            choose_lang () {
                $('.choose-language').toggle()
            },
            user () {
                $('.user').toggle()
            },
            search () {
                $('.search-input').toggle()
            },
            ok () {
                this.$Message.info('点击了确定')
            },
            cancel () {
                this.$Message.info('点击了取消')
            },
            shopping () {
                this.fetchData()
                $('.Srig').animate({width: '500px'})
                $('.shopping-car-page').fadeIn(1500)
            },
            shopping_hide () {
                $('.shopping-car-page').hide()
                $('.Srig-group').hide()
                $('.Srig').animate({width: '0'}, 500)
                // 成功刷新页面
                this.$router.go(0)
            },
            shopping_hide_1(){
                $('.shopping-car-page').hide()
                $('.Srig').animate({width: '0'}, 500)
                $('.Srig-group').hide()
            },
            min (index) {
                this.updateCart(index, 'delcart', [
                    1,
                    this.goods[index]['store_count']
                ])
            },
            max (index) {
                this.updateCart(index, 'addcart',
                    [
                        1,
                        this.goods[index]['store_count']
                    ])
            },
            updateCart (index, type = 'addcart', range = [1, 99]) {
                let module = 'index.php/index/shopcar/' + type
                let data = {}
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                if (!this.Local.isLogin()) {
                    data.tourists_token = this.Local.get('tourists_token')
                }else{
                    data.user_id = this.Local.getUserId()
                }
                data.token = this.Local.getUserToken()
                data.lang = this.$i18n.locale
                data.goods_id = this.goods[index]['goods_id']
                data.number = 1

                if (type === 'delcart' && this.goods[index]['goods_num'] === range[0]) {
                    return false
                }
                if (type === 'addcart' && this.goods[index]['goods_num'] === range[1]) {
                    return false
                }
                this.$http.post(process.env.BASEURL + module, data)
                .then(function (response) {
                    if (parseInt(response.data.code) === 2000) {
                        if (type === 'addcart') {
                            this.goods[index]['goods_num'] += 1
                            this.fetchData()
                            if (this.goods[index]['goods_num'] > range[1]) {
                                this.goods[index]['goods_num'] = range[1]
                            }
                        } else {
                            this.goods[index]['goods_num'] -= 1
                            if (this.goods[index]['goods_num'] < range[0]) {
                                this.goods[index]['goods_num'] = range[0]
                            }
                        }
                    } else {
                        alert('网络错误')
                    }
                }.bind(this))
            },
            remove_order (index) {
                let module = 'index.php/index/shopcar/delcart'
                let data = {}
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                if (!this.Local.isLogin()) {
                    data.tourists_token = this.Local.get('tourists_token')
                }else{
                    data.user_id = this.Local.getUserId()
                }
                data.token = this.Local.getUserToken()
                data.lang = this.$i18n.locale
                data.goods_id = this.goods[index]['goods_id']
                data.number = this.goods[index]['goods_num']
                this.$http.post(process.env.BASEURL + module, data)
                .then(function (response) {
                    if (parseInt(response.data.code) === 2000) {
                        this.goods.splice(index, 1)
                        this.$busEvent.$emit('delcart', 1)
                    }
                }.bind(this))
            },
            fetchData () {
                let module = 'index.php/index/shopcar/carinfo'
                let data = {}
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                if (!this.Local.isLogin()) {
                    data.tourists_token = this.Local.get('tourists_token')
                }else{
                    data.user_id = this.Local.getUserId()
                }
                data.token = this.Local.getUserToken()
                data.lang = this.$i18n.locale
                this.$http.get(process.env.BASEURL + module, {params: data})
                .then(function (response) {
                    this.goods = response.data.data
                }.bind(this))
            },
            //获取游客登录Token
            getCartToken () {
                let module = 'index.php/tourists/token';
                let _this = this;
                let data = {}
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                this.$http.get(process.env.BASEURL + module, {params: data})
                    .then(function (response) {
                        if (_this.Local.get('timeout') !== null) {
                        } else {
                            _this.Local.set('tourists_token',response.data.data.tourists_token)
                        }
//
                    }.bind(this))
            }
        },
        computed: {
            orderTotal () {
                let total = 0
                for (let item of this.goods) {
                    if (item.if_checked === true) {
                        total += parseFloat(item.goods_price) * parseInt(item.goods_num)
                    }
                }
                return total
            },
            orderNumberTotal () {
                let total = 0
                for (let item of this.goods) {
                    if (item.if_checked === true) {
                        total += parseInt(item.goods_num)
                    }
                }
                return total
            }
        },
        created () {
            //判断游客token是否存在
            if(!this.Local.get('tourists_token')){
                //获取游客登录Token
                this.getCartToken ()
            }else{
                // 判断过期
                let Carttimestamp = Date.parse(new Date()) / 1000
                let timeLength = 3600
                if(Carttimestamp - timeLength > this.Local.get('Carttimeout')){

                    //获取游客登录Token
                    this.getCartToken ()
                }else{
                    this.Local.set('Carttimeout', Carttimestamp)
                }
            }

            //购物车
            this.fetchData()

            this.$busEvent.$on('addCart', function (id) {
                this.fetchData()
            }.bind(this))

        },
        mounted () {
            window.addEventListener('scroll', this.menu)
        }
    }
</script>

<style lang="scss">
    @import "scss/common";
    @import url('https://fonts.googleapis.com/earlyaccess/notosansscsliced.css');


    #app {
        text-align: center;
        color: #2c3e50;
    }

    .shopping-number button:active{
        background: #0084FF !important;
    }
    .empty-cart {
        margin: 100px 0;
        p {
            line-height: 2;
            font-size: 16px;
            color: #777;
        }
        a {
            font-size: 16px;
            line-height: 2;
        }
    }
    .ivu-message-notice-content{
        font-size: 14px !important;
    }
    /*公共头部样式*/

    .layout-logo {
        max-width: 170px;
        min-width: 100px;
        height: 30px;
        border-radius: 3px;
        float: left;
        position: relative;
        top: 15px;
    }

    .max_width {
        max-width: 1200px;
        margin: 0 auto;
    }

    .layout-nav {
        width: 600px;
        margin: 0 auto;
    }

    .ivu-menu {
        background: transparent;
        background-image: linear-gradient(-180deg, rgba(66, 89, 112, 0.80) 0%, rgba(66, 89, 112, 0.00) 100%);
        color: white;
        height: 80px;
    }

    .ivu-menu-horizontal.ivu-menu-light:after {
        display: none;
    }

    .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item {
        color: white;
        font-size: 16px;
        margin-top: 25px;
        line-height: 30px;
        margin-right: 10px;
    }

    .other-nav {
        padding-top: 15px;
    }

    .search-btn {
        background: transparent;
        border: none;
        outline: none;
        color: white;
    }

    .other-icon {
        padding-left: 20px;
    }

    .selected {
        border: 1px solid #2c3e50 !important;
    }

    .selected1 {
        border: 1px solid #ffffff !important;
    }

    .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item-active, .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item:hover, .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu-active, .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu:hover {
        border: 1px solid #ffffff;
        border-radius: 5px;
        color: white;
    }
    .Social_group{
        position: relative;
    }
    .Social_icon{
        width: 25%;
        float: left;
        padding: 10px 0 20px 0;
        text-align: left;

    }
    .Social_qrcode{
        width:132px;
        height: auto;
        background: #FFFFFF;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
        position: absolute;
        bottom: 0;
        left: 65%;
        p{
            font-size: 14px;
            /*font-family: PingFangSC-Regular;*/
            padding-bottom: 5px;
        }
        img{
            width: 112px;
            margin-top: 10px;
        }
        #mydiv {
            width: 0;
            height: 0px;
            content: '';
            border-style: solid;
            border-width: 6px;
            border-color: #fff #fff transparent transparent;
            transform: rotate(135deg);
            box-shadow: 2px -2px 2px rgba(0, 0, 0, 0.5);
            position:absolute;
            bottom: -5px;
            left: 60px;
        }
    }
    /*公共尾部样式*/
    .layout-copy1 {
        text-align: center;
        padding: 10px 0 40px;
        background: #FFFFFF;
        font-size: 14px;
        color: #1F2D3D;
        padding-top: 20px;
    }

    .layout-copy {
        text-align: center;
        background: #FFFFFF;
        box-shadow: 0 -2px 5px 0 rgba(31, 45, 61, 0.20);
        color: #1F2D3D;
    }

    .copy-title {
        font-size: 16px;
        color: #1F2D3D !important;
        line-height: 20px;
        margin: 10px 0 10px 0;
        text-align: left;
    }

    .copy-title1 {
        margin: 40px 0 40px 0;
    }

    .copy-item {
        font-size: 14px;
        color: #1F2D3D;
        margin: 5px 0;
        letter-spacing: 0;
        line-height: 20px;
        text-align: left;
        font-weight: 500;
    }

    .copy-item:hover {
        color: #0084FF !important;
    }

    .copy-header {
        margin: 0 auto;
        width: 150px;
    }

    .copy-title a, .copy-item a {
        color: white;
    }

    .qr_code {
        font-size: 14px;
        color: #1f2d3d;
        line-height: 20px;
    }

    .qr-main {
        max-width: 380px;
        margin: 0 auto;
    }

    .mobile-menu {
        line-height: 40px;
        border-bottom: 1px solid #666;
    }

    .ivu-select-selection {
        border: none;
        background: none;
        width: 100px;
    }

    .ivu-select-selected-value {
        color: white;
    }

    .choose-language div:hover {
        background: #5E6D82;
    }

    .user div span:hover {
        color: #1F2D3D !important;
    }

    .layout-copy-main {
        width: 85%;
        margin: 30px auto;
        .footer-row {
            padding: 0 30px 0 30px;
        }
    }

    .Product-shopping-btn {
        border: 1px solid #0084FF;
        border-radius: 5px;
        height: 40px;
        width: 150px;
        font-size: 20px;
        color: white;
        background: #0084FF;
        margin: 5% 0 5% 0;

    }

    .top {
        background: #ffffff;
        width: 80px;
        padding: 8px;
        background: #FFFFFF;
        box-shadow: 2px 3px 10px 0 rgba(94,109,130,0.50);
        border-radius: 5px 0 0 5px;
        text-align: center;
        font-size: 14px;
        img {
            width: 30px;
        }
    }
    .ivu-back-top{
        right: 0px !important;
    }

    .Product-more {
        color: #0084FF;
    }

    .layout-copy {
        .ivu-row {
            margin: 0 auto;
        }
    }

    #pc_footer {
        margin-top: 7%;
    }
    /*QR Code*/
    .qr_code_group{
        .ivu-modal-header,.ivu-modal-footer{
            border: none !important;
        }
    }
    @media (max-width: 768px) {
        .layout-copy-main {
            border: none;
        }

        .qr-main {
            margin: 0 auto;
        }
    }

    /*公共轮播样式*/
    .ivu-carousel-dots-inside {
        display: none;
    }

    .banner-title {
        line-height: 40px;
    }

    .banner-content {
        font-weight: 500;
        font-size: 20px;
    }

    .ivu-carousel-arrow {
        font-size: 1.4rem;
    }

    @media screen and (max-width: 1380px) {
        .layout-logo {
            left: 2%;
        }

        .layout-nav {
            width: 650px;
        }
    }

    @media screen and (max-width: 1240px) {
        .layout-logo {
            width: 130px;
        }

        .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item {
            font-size: 15px;
            padding: 0 15px 0 15px;
        }

        .other-icon {
            padding-left: 10px;
        }

    }

    @media screen and (max-width: 1023px) {
        .ivu-menu {
            height: 60px;
            background: rgb(31, 45, 61) !important;
        }

        #layout_2 {
            display: block !important;
        }

        #layout_1 {
            display: none;
        }

    }

    @media screen and (max-width: 992px) {
        .log-reg-main {
            border-right: none !important;
        }
    }

    @media screen and (max-width: 769px) {
        body .modal-1 .ivu-modal {
            width: 90% !important;
            margin: 0 auto;
            min-width: 290px;
        }
        .layout-copy-main {
            width: 100%;
            padding: 10px;
            margin: 0;
            .footer-row {
                padding: 0;
                .copy-header {
                    width: 100%;
                }
            }
        }
    }

    @media screen and (max-width: 677px) {
        .other-nav {
            width: 100%;
            margin-right: 5px;
        }

        .other-nav img {
            width: 15px;
        }

        .user, .choose-language {
            margin-left: -40px;
        }
    }

    @media screen and (max-width: 500px) {
        #search {
            display: none;
        }

        #lang {
            display: none;
        }

        #mobile-lang {
            display: block !important;
        }
        .qr-main{
            padding:0 10px;
        }

    }

    /*登录注册*/
    .modal-1 .ivu-modal {
        width: 65% !important;
        background: #EFF2F7;
        border: 1px solid #5E6D82;
        border-radius: 5px;
        max-width: 1100px;
    }

    .ivu-checkbox-inner {
        width: 16px;
        height: 16px;
    }

    .login-register-btn button {
        border: 1px solid #0084FF;
        border-radius: 5px;
        background: #0084FF;
        width: 30%;
        min-width: 120px;
        height: 34px;
        font-size: 16px;
        color: #ffffff !important;
        margin: 3% 0 5% 0;
    }

    .login-register-btn button:hover {
        color: white !important;
        background: #0084FF;
    }

    .resgister-main input, .login-main input {
        padding-left: 8px;
    }

    /*购物车*/
    .modal-register .ivu-modal-footer {
        display: none;
    }

    .ivu-checkbox-checked .ivu-checkbox-inner:after {
        width: 7px;
        height: 10px;
        top: 2px;
        left: 5px;
    }

    .ivu-checkbox-inner {
        height: 20px;
        width: 20px;
    }

    .Srig {
        z-index: 1010;
        width: 0;
        height: 100%;
        background: #F9FCFF;
        position: fixed;
        top: 0;
        right: 0;
        overflow: hidden;
    }
    .Srig-group{
        width: 100%;
        height: 100%;
        display: none;
        position: fixed;
        background: black;
        opacity: 0.4;
        z-index: 1009;
        top:0;
    }

    .shopping-car-page {
        width: 90%;
        margin: 20px auto;
        display: none
    }

    .shopping_span {
        font-size: 16px;
        color: #5E6D82;
        margin-left: 5px;
        position: absolute;
        top: 18px;
    }

    .shopping-title {
        margin-top: 2%;
        font-size: 42px;
    }

    .mobile-footer {
        display: none;
    }

    @media screen and (max-width: 414px) {
        #pc_footer {
            display: none;
        }
        .mobile-footer {
            display: block;
        }
        .ivu-collapse, .ivu-collapse-content {
            background: #F9FCFF;

        }
        .ivu-collapse-header {
            color: #1f2d3d;
        }
        .copy-item {
            display: block;
        }
        .ivu-collapse > .ivu-collapse-item > .ivu-collapse-header {
            text-align: left;
            padding-left: 16px;
            font-size: 14px;
        }
        .copy-item{
            color: #666;
        }
        .ivu-collapse-content > .ivu-collapse-content-box {
            padding: 0;

        }
        .ivu-back-top{

        }
        .top{
            width: 50px;
            p{
                display: none;
            }
        }

    }

    .shopping-car-main-page {
        max-height: 500px;
        overflow-y: scroll;
    }
    .shopping-car-main-page::-webkit-scrollbar {
        display:none
    }


    @media (max-device-height: 786px) {
        .shopping-car-main-page {
            max-height: 300px;
            overflow: scroll;
        }
    }

    @media (max-device-height: 600px) {
        .shopping-car-main-page {
            max-height: 230px;
            overflow: scroll;
        }
    }
</style>



// WEBPACK FOOTER //
// App.vue?24febb27